import { Box, Stack, Text } from '@chakra-ui/react'

import ModalV3 from '@/components/UI/Modal/ModalV3'

import { DownloadPDFButton, type DownloadPDFButtonProps } from './DownloadPDFButton'

export function DownloadPDFModal({
  isOpen,
  onClose,
  ...props
}: { isOpen: boolean; onClose: () => void } & DownloadPDFButtonProps): JSX.Element {
  return (
    <ModalV3
      title="Download PDF"
      size="2xl"
      open={isOpen}
      onClose={onClose}
      body={() => (
        <Stack spacing="16px">
          <Text>Click on the button below to download a PDF of your volunteer hours.</Text>
          <Box textAlign="center">
            <DownloadPDFButton {...props} />
          </Box>
        </Stack>
      )}
    />
  )
}
